import { render, staticRenderFns } from "./CourseComeDown.vue?vue&type=template&id=03c1d384&scoped=true&"
import script from "./CourseComeDown.vue?vue&type=script&lang=js&"
export * from "./CourseComeDown.vue?vue&type=script&lang=js&"
import style0 from "./CourseComeDown.vue?vue&type=style&index=0&id=03c1d384&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c1d384",
  null
  
)

export default component.exports